import { useIsLoggedIn, useUserStore } from '@ekonavi/auth'

import { cn, contentMaxWidth } from '@/lib/utils'
import { HeaderActionButton } from './header-action-button'
import { useHeaderEffects } from './header-effects'
import { useResolveNavigate } from '../../hooks/use-resolve-navigate'
import { ThemeSwitcher } from '../theme-switcher'
import { useUIStore } from '@/store/ui-store'

export function Header() {
	const { user } = useUserStore()
	const isLoggedIn = useIsLoggedIn()
	const resolveNavigate = useResolveNavigate()
	const { editorMode, editorModeText } = useUIStore()

	const iconSize = isLoggedIn ? '60px' : '80px'

	useHeaderEffects()

	// Editor mode: minimal header (25px height) with breadcrumb
	if (editorMode) {
		return (
			<div className='fixed  w-full top-0 bg-secondary h-[25px] z-[99] border-b border-border/30'>
				<div className='mx-auto w-full h-full flex items-center justify-start pl-4'>
					<span className='text-sm font-semibold  truncate'>{editorModeText || 'EKONAVI'}</span>
				</div>
			</div>
		)
	}

	// Normal mode: full header
	return (
		<div className={`fixed  px-2 w-full top-0    bg-secondary  h-[var(--header-height)] z-[99] leve-border-bottom-light `}>
			<div className=' mx-auto w-full px-1 pr-1 h-full'>
				<div className={cn('mx-auto  grid grid-cols-3 h-full relative ', contentMaxWidth)}>
					<span
						onClick={() => resolveNavigate({ path: '/' })}
						className='text-3xl font-extrabold transition-colors hover:opacity-70 pt-1 cursor-pointer w-[100px]'>
						EKONAVI
					</span>

					<div className={` flex flex-col items-center justify-center pt-4 relative `}>
						<img
							onClick={() => resolveNavigate({ path: '/painel' })}
							src='/EKONAVI-logo-icon.svg'
							alt='logo'
							style={{ width: iconSize, height: iconSize }}
							className={cn('absolute cursor-pointer rounded-full bg-primary shadow-md', isLoggedIn && 'fixed bottom-6 z-[9999] right-0 left-0  mx-auto border-black/10  ')}
						/>
					</div>

					<div className={`justify-end flex items-center `}>
						<HeaderActionButton />
					</div>
					<div className={`absolute top-10 w-full  max-w-[280px] `}>{user?.username || user?.email || `Bem-vindo`}</div>
				</div>
			</div>
		</div>
	)
}
